import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal, Checkbox } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { MODAL_ACCEPT_TERMS_AND_CONDITIONS } from '../../../../reducers/Modal/types';
import { setModalState } from '../../../../reducers/Modal/actions';
import { ZorbaButton } from '../../../../components/forms';
import { acceptTermsAndConditions } from '../../../../reducers/Auth/actions';
import { GeneralTerms } from './GeneralTerms';

import './index.scss';

export const AcceptTermsAndConditionsModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isRead, setIsRead] = useState(false);
  const { isAcceptTermsAndConditionsModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const { userDetails, isAppLoading, isAuthLoading } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
  };

  useEffect(() => {
    if (
      !isAuthLoading &&
      !isAppLoading &&
      userDetails?.isCompletedOnboarding &&
      !userDetails?.defaultOrganization?.termsOfUse?.signedAt &&
      userDetails?.defaultOrganization?.verification?.verified
    ) {
      dispatch(setModalState(MODAL_ACCEPT_TERMS_AND_CONDITIONS, true));
    }
  }, [userDetails]);

  const containerRef = useRef();
  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    if (scrollTop + clientHeight - scrollHeight >= -1) {
      setIsRead(true);
    }
  }, [containerRef]);

  const marketplacePartner =
    userDetails?.defaultOrganization?.marketplacePartner;

  const handleClose = () => {
    dispatch(setModalState(MODAL_ACCEPT_TERMS_AND_CONDITIONS, false));
    history.push('/buybox');
  };

  const handleAcceptTermsAndConditions = () => {
    dispatch(acceptTermsAndConditions(handleClose));
  };

  return (
    <Modal
      open={isAcceptTermsAndConditionsModalOpen}
      footer={null}
      title="Terms and Conditions"
      destroyOnClose
      closable={false}
      className="terms-and-conditions-modal"
    >
      {marketplacePartner ? (
        <GeneralTerms handleScroll={handleScroll} containerRef={containerRef} />
      ) : (
        <GeneralTerms handleScroll={handleScroll} containerRef={containerRef} />
      )}
      <div className="checkbox-container">
        <Checkbox
          checked={isCheckboxChecked}
          onChange={handleCheckboxChange}
          disabled={!isRead}
        >
          I agree to these terms and conditions
        </Checkbox>
      </div>
      <div className="button-container">
        <ZorbaButton
          disabled={!isCheckboxChecked}
          onClick={handleAcceptTermsAndConditions}
        >
          Accept
        </ZorbaButton>
      </div>
    </Modal>
  );
};
